import React, { useEffect, useState } from "react";
import altLogo from "../images/ameya_logo.svg";
import { Shimmer } from "react-shimmer";
import FilesApi from "../Api/Services/AppflyteBackend/FileServiceApi";
import { ReactSVG } from "react-svg";
let bucket_name = window.__ENV__.S3_BUCKET_NAME

export default function LoadAppLogo({ logo_path }) {
    const [logoUrl, setLogoUrl] = useState(null);
    const [loading, setLoading] = useState(false);

    const loadLogo = async () => {
        setLoading(true);
        try {
            if (logo_path) {
                const logo_res = await FilesApi.getDownloadUrl(bucket_name, logo_path);
                if (logo_res.status === 200) {
                    const logo_res_data = logo_res?.data?.at(-1) ?? null;
                    const logo_url = Object.values(logo_res_data)?.at(-1) ?? null;
                    if (logo_url) {
                        setLogoUrl(logo_url)
                    }
                }
            }
        } catch (err) {
            console.error("Logo load failed:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadLogo();
        return () => {
            if (logoUrl) {
                URL.revokeObjectURL(logoUrl);
            }
        };
        //eslint-disable-next-line
    }, [logo_path]);

    if (loading) return <Shimmer width={204} height={53} />;

    const isSvg = logoUrl?.includes(".svg");

    return logoUrl
        ?
        (isSvg
            ?
            (<ReactSVG src={logoUrl}
                beforeInjection={(svg) => {
                    svg.setAttribute("style", "width:100%; height:100%; object-fit:contain;");
                }}
            />)
            :
            (<img src={logoUrl} alt="Logo" style={{ maxWidth: 300, maxHeight: 100 }} />)
        )
        :
        (<img src={altLogo} alt="Fallback Logo" style={{ maxWidth: 300, maxHeight: 100 }} />)
}